<template>
  <div class="mirco-app-report preview">
    <micro-app
      :name="microName"
      :url="getUrl"
      iframe
      router-mode="native"
      :baseroute="`/${microName}`"
      :data="storeInfo"
      keep-alive
      @datachange="handleDataChange"
    ></micro-app>
  </div>
</template>
<script lang="ts">
import microApp, { EventCenterForMicroApp } from '@micro-zoe/micro-app';
import configEnv from '@/config/user.env';
import { useStore } from 'vuex';
import { computed, defineComponent, nextTick, onMounted, reactive, ref, toRefs, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import eventBus from '@/utils/eventBus';
import { lotsUIEventInstance } from '@annto/ui';
import { logout } from '@/utils/index';
import { handleMicroBigDataTrack } from '@/utils/bigLogData/trackHelper';
declare global {
  interface Window {
    eventCenterForAppNameVite: any;
  }
}

// // 因为vite子应用关闭了沙箱，我们需要为子应用appname-vite创建EventCenterForMicroApp对象来实现数据通信
window.eventCenterForAppNameVite = new EventCenterForMicroApp('csp');

export default defineComponent({
  setup() {
    const storeInfo = ref({});
    const state = reactive({
      router: {},
      user: null,
      authority: null,
      currentTenant: null,
      appId: null,
      appList: null,
      btnPermissions: null,
      path: '',
      query: {},
      applicationCode: '',
    });
    const store = useStore();

    const route = useRoute();
    const router = useRouter();
    const microName = 'microCsp';

    // 专门监听 query 参数的变化
    // watch(() => route.query, (newQuery, oldQuery) => {
    //     if (JSON.stringify(newQuery) !== JSON.stringify(oldQuery)) {
    //     initPage();
    //   }
    // }, { deep: true });
    watch(
      () => ({ path: route.path, query: route.query }),
      (newVal, oldVal) => {
        // 只有当路径或查询参数真正发生变化时才调用 initPage
        if (newVal.path !== oldVal?.path || JSON.stringify(newVal.query) !== JSON.stringify(oldVal?.query)) {
          initPage();
        }
      },
      { deep: true }
    );

    microApp.getData(microName);

    const getUrl = computed(() => {
      return configEnv.microCspUrl;
    });

    const initPage = () => {
      const routeInfo = microApp.router.current.get(microName);
      if (routeInfo && microApp.router.decode(route.path).includes(microName)) {
        if (`/#${route.path}` !== routeInfo.fullPath) {
              // 把nextTick改成setTimeout可解决再去登录的时候，停留在我上个账号最后访问的页面问题
              setTimeout(() => {
                  microApp.router.push({ name: microName, path: `/#${route.fullPath}`, query: route.query || {} });
              });
          }
        microApp.setData(microName, { path: `/#${route.fullPath}`, params: route.query || {} });
      }

      state.router = router; // 假设 router 是从 useRouter 获取的
      state.user = store.getters.user; // 从 Vuex 获取用户信息
      state.authority = store.getters.authority;
      state.currentTenant = store.getters.currentTenant;
      state.appId = store.getters.appId;
      state.appList = store.getters.appList;
      state.btnPermissions = store.getters.btnPermissions;
      state.applicationCode = store.state.applicationCode;
      state.path = route.path;
      state.query = route.query;

      const { user, authority, currentTenant, appId, appList, btnPermissions, path, query, applicationCode } =
        toRefs(state);
      // 这里的一些参数除了重点说明的两个一般物流的项目都会有;
      storeInfo.value = {
        type: 'updateData',
        router,
        user,
        authority,
        currentTenant,
        appId,
        appList,
        btnPermissions,
        path,
        query,
        applicationCode,
        lotsUIEventInstance,
      };
    };

    const handleDataChange = (val: any) => {
      const data = val.detail.data;
      if (handleMicroBigDataTrack(data, route.path)) return;
      // 子应用可以通过这个函数关闭当前页面
      if (data.type === 'closeActiveView') {
        const { view } = data;
        const findView = store.getters.visitedViews.find((item: any) => {
          return item.href === view.href;
        });
        if (findView && findView.fullPath) {
          store.dispatch('delView', findView);
        }
      } else if (data.type === 'routes') {
        const { routes, lang } = data;
        store.commit('updateMicroRoutes', { microName, routes, lang });
        store.commit('UPDATE_VISITED_TITLE');
      } else if (data.type === 'logout') {
        logout();
      }
    };

    // 监听关闭标签事件
    const closeSelectedTag = (view: any) => {
      microApp.setData(microName, { type: 'closeSelectedTag', view });
    };
    eventBus.$on('closeSelectedTag', closeSelectedTag);

    onMounted(() => {
      initPage();
    });

    return {
      microName,
      storeInfo,
      getUrl,
      handleDataChange,
    };
  },
});
</script>
<style lang="less">
.mirco-app-report {
  height: 100%;

  micro-app[name='microCsp'] {
    width: 100%;
    height: 100%;
    .root-panel {
      height: 100%;
    }
    .detailDrawer .detail-drawer-body{
        width: 88% !important;
    }
  }
}

</style>
  